export function getCurrentValue(value, defaultValue) {
  return value !== undefined && value !== null ? value : defaultValue ? defaultValue : "";
}
